<div class="modal-header">
  <h4 class="modal-title">Subir archivo Excel</h4>
  <button type="button" class="btn-close" aria-label="Cerrar" (click)="onClose()"></button>
</div>

<div class="modal-body">
  <p class="text-muted small mb-2">
    El archivo se envía al servidor con el campo <code>excel</code> (formato .xlsx).
  </p>
  <p class="small mb-3">
    <a
      class="link-primary"
      href="/assets/admin/cemento/politica-entrega-carga-masiva-ejemplo.xlsx"
      download="politica-entrega-carga-masiva-ejemplo.xlsx"
      target="_blank"
      rel="noopener noreferrer"
    >
      Descargar plantilla de ejemplo (.xlsx)
    </a>
  </p>
  <label class="form-label d-block mb-2" for="polEntregaExcelFile">Archivo Excel</label>
  <input
    #excelFileInput
    type="file"
    id="polEntregaExcelFile"
    class="d-none"
    accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    (change)="onExcelFileChange($event)"
  />
  <div class="politicas-carga-masiva-acciones d-flex flex-column gap-3 align-items-stretch">
    <app-cbb-button
      label="Elegir archivo"
      color="outline"
      type="button"
      (action)="triggerExcelFileInput()"
    ></app-cbb-button>
    <p class="small mb-0 politicas-carga-masiva-nombre" [class.text-muted]="!nombreArchivoExcel">
      {{ nombreArchivoExcel || 'Ningún archivo seleccionado' }}
    </p>
  </div>
  <div *ngIf="errorArchivoExcel" class="text-danger mt-2">
    Solo se permiten archivos Excel (.xlsx).
  </div>
</div>

<div class="modal-footer">
  <app-cbb-button
    label="Subir"
    color="green"
    (action)="onUpload()"
    [disabled]="!archivoExcel"
  ></app-cbb-button>
</div>
